
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-header-calendar-area',
})
export default class Header extends Vue {
  @Prop({ type: String, default: 'public' }) readonly layout: string;

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get isPublicLayout(): boolean {
    return this.layout == 'public';
  }

  get isPOSLayout(): boolean {
    return this.layout == 'pos';
  }

  get calendarRoute() {
    return this.isPOSLayout ? 'admin-calendar' : 'calendar-public';
  }
}
